/*
  Also Green popup (2026-10-25). Shows our own popup (sections/ag-popup.liquid) to eligible
  visitors on this theme, splitting them between variants when there is more than one. Tracks
  views, steps and signups on the stats server and tags the cart (_ag_popup) so orders can be
  tied back to the variant. The Klaviyo popup is stopped on this theme by ag-popup-test.liquid
  and is never touched elsewhere. Settings: sections/ag-popup-test.liquid.
  Preview: ?agp=<variant name> (no tracking, no Klaviyo calls). ?agp=reset, ?agp=off.
  Write-up: Website/popup-test-10-25/POPUP-TEST-CHANGES.md
*/
(function () {
  'use strict';

  var cfgEl = document.getElementById('agp-config');
  if (!cfgEl || window.__agp) return;
  window.__agp = true;

  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var DAY = 864e5;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var html = document.documentElement;
  var params = new URLSearchParams(location.search);
  var MOBILE = window.matchMedia('(max-width: 749px)').matches;
  var KL_REVISION = '2024-10-15';

  /* ---------- storage ---------- */

  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }

  // Preview mode (?agp=<variant>) sticks in this browser for 7 days, across tabs and pages, until
  // ?agp=off. ?agp=reset starts the popup over but stays in preview. The inline script in
  // ag-popup-test.liquid reads the same agp_force key to keep Klaviyo's popup shut.
  // ?agp_live=1 alongside: preview that really signs up to Klaviyo (one-off end-to-end check).
  var forceParam = params.get('agp');
  var force = lsGet('agp_force');
  if (force && !(force.v && force.exp > Date.now())) { force = null; lsDel('agp_force'); }
  if (forceParam === 'off') { force = null; lsDel('agp_force'); }
  else if (forceParam === 'reset') {
    try {
      Object.keys(localStorage).forEach(function (k) {
        if (k.indexOf('agp') === 0 && k !== 'agp_force' && k !== 'agp_vid') localStorage.removeItem(k);
      });
    } catch (e) {}
  } else if (forceParam) {
    force = { v: forceParam, live: false, exp: Date.now() + 7 * 864e5 };
  }
  if (force && params.get('agp_live') === '1') force.live = true;
  if (force) lsSet('agp_force', force);
  if (forceParam === 'off' || forceParam === 'reset') {
    // Drop it from the URL so a reload doesn't reset again.
    params.delete('agp');
    try { history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : '') + location.hash); } catch (e) {}
  }
  var FORCE = force ? force.v : null;
  var PREVIEW = !!FORCE || DESIGN;
  var KL_LIVE = !DESIGN && !!force && force.live === true;

  // st = this test round (variant, step, answers). G = this browser across every round: closes,
  // when it was last closed or opened, pill dismissed, signed up, finished. A new test name starts
  // a new round but never re-pops for someone who closed it recently or already signed up.
  var STATE_KEY = PREVIEW ? 'agp:preview' : 'agp:' + C.test;
  var G_KEY = PREVIEW ? 'agp_seen_preview' : 'agp_seen';
  var st = lsGet(STATE_KEY) || {};
  var G = lsGet(G_KEY) || {};
  if (G.signed && !st.submitted) st.submitted = G.signed;
  if (G.done) st.done = 1;
  function save() {
    if (st.submitted) G.signed = G.signed || st.submitted;
    if (st.done) G.done = 1;
    lsSet(STATE_KEY, st);
    lsSet(G_KEY, G);
  }

  var vid = lsGet('agp_vid');
  if (!vid) {
    vid = Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-6);
    lsSet('agp_vid', vid);
    lsSet('agp_vid_at', Date.now());
  }

  /* ---------- traffic source (first touch, kept 30 days) ---------- */

  function channelOf(us, um, ref) {
    var both = us + ' ' + um;
    if (params.get('fbclid') || /^(fb|facebook|ig|instagram|meta)/.test(us)) return 'meta';
    if (params.get('gclid') || params.get('gbraid') || params.get('wbraid') || (us === 'google' && /cpc|ppc|paid/.test(um))) return 'google_ads';
    if (params.get('ttclid') || /^tiktok/.test(us)) return 'tiktok';
    if (params.get('_kx') || /klaviyo|email|newsletter/.test(both)) return 'email';
    if (/\bsms\b|text/.test(both)) return 'sms';
    if (/cpc|ppc|paid|display|^ads?$/.test(um)) return 'other_paid';
    if (us) return 'other_tagged';
    if (/(^|\.)(google|bing|duckduckgo|yahoo|ecosia|brave)\./.test(ref)) return 'search';
    if (/(^|\.)(facebook|instagram|pinterest|reddit|tiktok|youtube|linkedin|threads|x|twitter)\.|^t\.co$|^lnkd\.in$/.test(ref)) return 'social';
    if (ref) return 'referral';
    return 'direct';
  }

  var attr = lsGet('agp_attr');
  if (!attr || !(attr.exp > Date.now())) {
    var ref = '';
    try {
      ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : '';
      if (/(^|\.)(also\.green|myshopify\.com|shopify\.com|shop\.app)$/.test(ref)) ref = '';
    } catch (e) {}
    var up = function (k) { return (params.get(k) || '').slice(0, 80); };
    var us = up('utm_source').toLowerCase(), um = up('utm_medium').toLowerCase();
    attr = { ch: channelOf(us, um, ref), us: us, um: um, uc: up('utm_campaign'), lp: location.pathname.slice(0, 200), rd: ref.slice(0, 80), exp: Date.now() + 30 * 864e5 };
    if (!PREVIEW) lsSet('agp_attr', attr);
  }
  // New = first seen on this theme within the last 30 minutes.
  function attrFields() {
    var at = lsGet('agp_vid_at');
    return { ch: attr.ch, us: attr.us, um: attr.um, uc: attr.uc, lp: attr.lp, rd: attr.rd, nv: at && Date.now() - at < 18e5 ? 1 : 0 };
  }

  function log() { if (PREVIEW && window.console) console.log.apply(console, ['[agp]'].concat([].slice.call(arguments))); }

  /* ---------- tracking ---------- */

  // Visitors who click "Decline" on the cookie banner aren't counted: no stats, no cart tag.
  // The popup itself still works for them (a signup is their own choice).
  function analyticsOK() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (e) {}
    return true;
  }

  function track(type, extra) {
    var ev = { k: C.test, a: st.arm, v: vid, t: type, p: location.pathname, d: MOBILE ? 'm' : 'd' };
    if (extra) for (var x in extra) ev[x] = extra[x];
    if (PREVIEW || !C.endpoint) { log('track', ev); return; }
    if (!analyticsOK()) return;
    var url = C.endpoint.replace(/\/+$/, '') + '/e';
    var body = JSON.stringify(ev);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    try { fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
  }

  // Cart attribute read by the order pixel: test|arm|v(iewed)/s(igned up)|visitor
  var cartVal = C.cartTag || '';
  var cartReady = document.readyState === 'complete';
  if (!cartReady) window.addEventListener('load', function () { cartReady = true; setTimeout(syncCart, 400); });
  function syncCart() {
    if (PREVIEW || !st.arm || !cartReady || !analyticsOK()) return;
    var val = [C.test, st.arm, st.submitted ? 's' : 'v', vid].join('|');
    if (val === cartVal) return;
    cartVal = val;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _ag_popup: val } })
    }).catch(function () { cartVal = ''; });
  }

  /* ---------- who is in the test ---------- */

  function identified() {
    if (C.customer || params.get('_kx')) return true;
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (m) {
      try {
        var o = JSON.parse(atob(decodeURIComponent(m[1])));
        if (o.$email || o.$exchange_id || o.$phone_number || o.$kx) return true;
      } catch (e) {}
    }
    return false;
  }

  // The page's path without market folder or collection (see ag-popup-test.liquid).
  var PATH = C.path || location.pathname;

  function excluded() {
    var p = PATH;
    return (C.exclude || []).some(function (x) { return x && p.indexOf(x) === 0; });
  }

  // Set by the order pixel (custom-pixel.js) on every completed checkout in this browser.
  // Buyers never get the signup discount popup.
  function isBuyer() {
    if (/(?:^|;\s*)agp_buyer=/.test(document.cookie)) return true;
    try { return !!localStorage.getItem('agp_buyer'); } catch (e) { return false; }
  }

  // How long to wait after the nth close before opening on its own again. Infinity = never (pill only).
  // A browser that hasn't closed it for 90 days starts over.
  var FORGET_MS = 90 * DAY;
  function waitAfter(closes) {
    if (!closes) return 0;
    if (closes >= (C.maxCloses || 3)) return Infinity;
    return (closes === 1 ? C.cooldownDays : (C.cooldownDays2 || C.cooldownDays)) * DAY;
  }

  /* ---------- variants ---------- */

  var variants = {};
  function collect() {
    variants = {};
    document.querySelectorAll('.agp[data-agp-key]').forEach(function (el) {
      variants[el.getAttribute('data-agp-key')] = el;
    });
  }
  collect();

  // Which popup designs belong on this page. "Pages and their popups" (Popup test settings), one
  // line per page: "/products/laundry-leaf-detergent-sheets: ll-surprise" (several names =
  // split between them; no names = all designs). First matching line wins. Empty = every
  // design on every page.
  function pageVariants() {
    var lines = String(C.pageMap || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    if (!lines.length) return Object.keys(variants);
    var p = PATH;
    for (var n = 0; n < lines.length; n++) {
      var i = lines[n].indexOf(':');
      var path = (i < 0 ? lines[n] : lines[n].slice(0, i)).trim();
      if (!path || p.indexOf(path) !== 0) continue;
      var names = i < 0 ? [] : lines[n].slice(i + 1).split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      return names.length ? names.filter(function (k) { return variants[k]; }) : Object.keys(variants);
    }
    return [];
  }

  function pickArm(candidates) {
    var arms = [];
    (candidates || Object.keys(variants)).forEach(function (k) {
      var w = parseFloat(variants[k].getAttribute('data-weight')) || 0;
      if (w > 0) arms.push([k, w]);
    });
    var total = arms.reduce(function (s, a) { return s + a[1]; }, 0);
    if (!total) return null;
    var r = Math.random() * total;
    for (var i = 0; i < arms.length; i++) { r -= arms[i][1]; if (r < 0) return arms[i][0]; }
    return arms[arms.length - 1][0];
  }

  function armValid(a) {
    var el = variants[a];
    return !!el && (parseFloat(el.getAttribute('data-weight')) || 0) > 0;
  }

  /* ---------- popup controller ---------- */

  var cur = null; // open/active popup: { el, key, steps, i, ... }
  var lastFocus = null;

  // Freeze the page behind the popup. overflow:hidden alone doesn't stop iOS (or trackpads on
  // some pages), so pin the body in place and put the scroll position back on close.
  var lockY = 0, locked = false;
  function lockScroll() {
    if (locked) return;
    locked = true;
    lockY = window.scrollY || document.documentElement.scrollTop || 0;
    var b = document.body.style;
    b.position = 'fixed';
    b.top = -lockY + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
    html.classList.add('agp-locked');
  }
  function unlockScroll() {
    if (!locked) return;
    locked = false;
    var b = document.body.style;
    b.position = b.top = b.left = b.right = b.width = '';
    html.classList.remove('agp-locked');
    try { window.scrollTo({ top: lockY, behavior: 'instant' }); } catch (e) { window.scrollTo(0, lockY); }
  }

  function Popup(el) {
    this.el = el;
    this.key = el.getAttribute('data-agp-key');
    this.sid = el.getAttribute('data-section-id');
    this.dialog = el.querySelector('.agp__dialog');
    this.steps = [].slice.call(el.querySelectorAll('.agp__step'));
    this.pill = document.getElementById('agp-pill-' + this.sid);
    this.media = el.querySelector('.agp__media img');
    // The desktop image from the markup, not currentSrc: on a phone-width load currentSrc is the
    // phone image, and writing that back into img.src showed it (cropped huge) on desktop.
    this.mediaSrc = this.media ? this.media.getAttribute('src') : '';
    this.i = -1;
    this.seen = {};
    this.bind();
  }

  Popup.prototype.idx = function (type) {
    for (var i = 0; i < this.steps.length; i++) if (this.steps[i].getAttribute('data-type') === type) return i;
    return -1;
  };

  Popup.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (e) {
      var t = e.target;
      if (t === self.el && self.el.getAttribute('data-outside') === 'true') return self.close('outside');
      if (t.closest('[data-agp-close]')) return self.close('x');
      if (t.closest('[data-agp-next]')) return self.next();
      if (t.closest('[data-agp-skip]')) return self.skip();
      var opt = t.closest('.agp__btn--option');
      if (opt) return self.answer(opt);
      var card = t.closest('.agp-card');
      if (card) return self.flip(card);
      if (t.closest('[data-agp-copy]')) return self.copy(t.closest('[data-agp-copy]'));
      if (t.closest('[data-agp-cta]')) return self.cta();
    });
    this.el.querySelectorAll('form[data-agp-form]').forEach(function (f) {
      f.addEventListener('submit', function (e) { e.preventDefault(); self.submit(f); });
    });
    this.el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.close('esc');
      else if (e.key === 'Tab') self.trap(e);
    });
    if (this.pill) {
      this.pill.querySelector('[data-agp-pill-open]').addEventListener('click', function () {
        track('pill_click');
        self.open('pill');
      });
      this.pill.querySelector('[data-agp-pill-close]').addEventListener('click', function () {
        G.pillOff = Date.now();
        save();
        self.hidePill();
        track('pill_close');
      });
    }
  };

  Popup.prototype.open = function (src, step) {
    if (cur && cur !== this) cur.hide();
    cur = this;
    this.hidePill();
    lastFocus = document.activeElement;
    this.el.hidden = false;
    this.el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    // Gift images sit in a <template>, which doesn't load them: fetch them now so a flip shows them at once.
    this.el.querySelectorAll('.agp-game__gifts').forEach(function (t) {
      t.content.querySelectorAll('img').forEach(function (img) { new Image().src = img.getAttribute('src'); });
    });
    void this.el.offsetWidth; // reflow so the fade-in runs (rAF stalls in background tabs)
    this.el.classList.add('is-open');
    lockScroll();
    // The close (X) fades in after a few seconds, so it isn't the first thing people see.
    var el = this.el;
    var closeDelay = DESIGN ? 0 : parseFloat(el.getAttribute('data-close-delay')) || 0;
    clearTimeout(this.closeTimer);
    el.classList.remove('is-closable');
    if (closeDelay > 0) this.closeTimer = setTimeout(function () { el.classList.add('is-closable'); }, closeDelay * 1000);
    else el.classList.add('is-closable');
    this.seen = {};
    var start = typeof step === 'number' ? step : (st.submitted ? this.idx('success') : ((st.steps || {})[this.key] || 0));
    if (start < 0 || start >= this.steps.length) start = 0;
    this.go(start, true);
    if (src !== 'design') {
      G.openAt = Date.now();
      save();
      track('view', { src: src });
    }
  };

  // Close without recording anything (editor, switching variants).
  Popup.prototype.hide = function () {
    var self = this;
    clearTimeout(this.closeTimer);
    this.el.classList.remove('is-open', 'is-closable');
    setTimeout(function () { if (!self.el.classList.contains('is-open')) self.el.hidden = true; }, 260);
    unlockScroll();
    if (cur === this) cur = null;
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  };

  Popup.prototype.close = function (how) {
    if (DESIGN) return this.hide();
    // Signed up but closing before the code: show the code first.
    var s = this.idx('success');
    if (st.submitted && s > this.i && how !== 'nav') return this.go(s);
    track('close', { i: this.i, st: this.type(), how: how });
    G.openAt = 0;
    // Signed up and on the last step: the X (and Esc / outside click) also take them to the
    // landing page, the same as the button.
    if (st.submitted && this.type() === 'success' && how !== 'nav' && !DESIGN) {
      save();
      return this.leave();
    }
    if (!st.submitted) {
      G.closedAt = Date.now();
      G.closes = (G.closes || 0) + 1;
      G.pillOff = 0;
      st.steps = st.steps || {};
      st.steps[this.key] = this.type() === 'game' ? 0 : Math.max(this.i, 0);
    }
    save();
    this.hide();
    if (!st.submitted) this.showPill();
  };

  Popup.prototype.type = function () {
    var s = this.steps[this.i];
    return s ? s.getAttribute('data-type') : '';
  };

  Popup.prototype.go = function (i, quiet) {
    if (i < 0 || i >= this.steps.length) return this.close('end');
    var self = this;
    this.steps.forEach(function (s, n) { s.hidden = n !== i; });
    this.i = i;
    var step = this.steps[i];
    this.el.setAttribute('data-step', step.getAttribute('data-type'));
    // Per-step image
    if (this.media) {
      var img = step.getAttribute('data-image');
      var want = img || this.mediaSrc;
      if (want && this.media.getAttribute('src') !== want) {
        var pic = this.media.parentNode;
        var source = pic.querySelector('source');
        if (source) source.srcset = img || source.getAttribute('data-orig') || source.srcset;
        if (source && !source.getAttribute('data-orig')) source.setAttribute('data-orig', source.srcset);
        this.media.src = want;
      }
    }
    if (!st.submitted && step.getAttribute('data-type') !== 'success') {
      st.steps = st.steps || {};
      st.steps[this.key] = i;
      save();
    }
    if (!this.seen[i]) {
      this.seen[i] = true;
      if (!DESIGN) track('step', { i: i, st: step.getAttribute('data-type') });
    }
    if (step.getAttribute('data-type') === 'success') this.reachedSuccess(step);
    if (!quiet || !MOBILE) {
      var f = step.querySelector('input:not(.agp__hp), button');
      setTimeout(function () { try { (f || self.dialog).focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
    var body = this.el.querySelector('.agp__body');
    if (body) body.scrollTop = 0;
  };

  Popup.prototype.next = function () { this.go(this.i + 1); };

  Popup.prototype.skip = function () {
    var t = this.type();
    track('skip', { i: this.i, st: t });
    this.next();
  };

  Popup.prototype.flip = function (card) {
    var step = this.steps[this.i];
    if (step.classList.contains('is-won') || card.classList.contains('is-flipped')) return;
    // Up to 3 gifts: the nth card picked shows gift n (ag-popup.liquid, .agp-game__gifts).
    var tpl = step.querySelector('.agp-game__gifts');
    if (tpl) {
      var gifts = tpl.content.querySelectorAll('.agp-prize');
      var k = step.querySelectorAll('.agp-card.is-flipped').length;
      if (gifts.length) card.querySelector('.agp-card__face').innerHTML = gifts[k % gifts.length].innerHTML;
    }
    card.classList.add('is-flipped');
    // Screen readers: the card now says what it is, and the result is read out.
    var prize = card.querySelector('.agp-card__face').textContent.trim();
    card.setAttribute('aria-label', prize);
    card.setAttribute('aria-disabled', 'true');
    var live = step.querySelector('[data-agp-live]');
    var need = parseInt(step.getAttribute('data-flips'), 10) || 3;
    var flipped = step.querySelectorAll('.agp-card.is-flipped').length;
    if (flipped < need) {
      if (live) live.textContent = prize + '. ' + (need - flipped) + ' to go.';
      return;
    }
    step.classList.add('is-won');
    if (live) live.textContent = 'You won ' + prize + '.';
    var self = this;
    var game = step.querySelector('.agp-game');
    // Celebrate once the last pick has turned over.
    if (game && game.getAttribute('data-confetti') !== 'false') setTimeout(function () { confetti(game); }, 450);
    var rest = step.querySelectorAll('.agp-card:not(.is-flipped)');
    rest.forEach(function (c) { c.setAttribute('aria-disabled', 'true'); c.tabIndex = -1; });
    // The cards they didn't pick turn over as losers, so their pick feels like the win.
    var labels = (game && game.getAttribute('data-lose') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    rest.forEach(function (c, n) {
      var face = c.querySelector('.agp-card__face');
      if (labels.length) {
        face.textContent = '';
        var span = document.createElement('span');
        span.textContent = labels[n % labels.length];
        face.appendChild(span);
      } else {
        face.innerHTML = '<svg class="agp-card__x" viewBox="0 0 24 24" aria-label="No prize"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" fill="none"/></svg>';
      }
      c.classList.add('is-lose');
    });
    setTimeout(function () {
      rest.forEach(function (c, n) { setTimeout(function () { c.classList.add('is-flipped'); }, n * 70); });
    }, 450);
    // A short beat on the full board (wins + losers), then on; the confetti keeps falling over the next step.
    setTimeout(function () { track('game_won', { i: self.i }); self.next(); }, 450 + rest.length * 70 + 450);
  };

  // A short confetti burst from the card grid, in the popup's colours. Skipped for reduced motion.
  function confetti(from) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden) return;
    var cs = getComputedStyle(from.closest('.agp') || from);
    var colors = [cs.getPropertyValue('--agp-accent'), cs.getPropertyValue('--agp-card-face'), '#4982cc', '#ffffff', '#f5c542']
      .map(function (c) { return c.trim(); }).filter(Boolean);
    var canvas = document.createElement('canvas');
    canvas.className = 'agp-confetti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = window.innerWidth, H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var r = from.getBoundingClientRect();
    var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    var parts = [];
    for (var n = 0; n < 140; n++) {
      var a = Math.random() * Math.PI * 2, v = 4 + Math.random() * 9;
      parts.push({
        x: ox + (Math.random() - 0.5) * r.width * 0.6, y: oy + (Math.random() - 0.5) * r.height * 0.4,
        vx: Math.cos(a) * v, vy: Math.sin(a) * v - 6,
        w: 6 + Math.random() * 6, h: 4 + Math.random() * 6,
        rot: Math.random() * 6.3, vr: (Math.random() - 0.5) * 0.4,
        c: colors[n % colors.length]
      });
    }
    var start = performance.now(), LIFE = 1800;
    (function frame(t) {
      var k = (t - start) / LIFE;
      ctx.clearRect(0, 0, W, H);
      if (k >= 1) { canvas.remove(); return; }
      ctx.globalAlpha = k > 0.7 ? (1 - k) / 0.3 : 1;
      parts.forEach(function (p) {
        p.vy += 0.35; p.vx *= 0.985; p.vy *= 0.985;
        p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.c;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      requestAnimationFrame(frame);
    })(start);
  }

  Popup.prototype.answer = function (btn) {
    var step = this.steps[this.i];
    var prop = step.getAttribute('data-prop') || 'answer_' + this.i;
    var val = btn.getAttribute('data-value');
    st.answers = st.answers || {};
    st.answers[prop] = val;
    save();
    step.querySelectorAll('.agp__btn--option').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
    track('answer', { i: this.i, q: prop, ans: val });
    if (st.email && (!PREVIEW || KL_LIVE)) klProfile({ email: st.email }, answersProps());
    var self = this;
    setTimeout(function () { self.next(); }, 180);
  };

  // Big providers and the domains they really use. Anything a typo away from one of these
  // (and not another real provider) gets a "Did you mean" suggestion.
  var PROVIDERS = {
    gmail: ['com'], hotmail: ['com', 'ca', 'co.uk', 'fr', 'it', 'de', 'es'], outlook: ['com', 'fr', 'de', 'es', 'it'],
    yahoo: ['com', 'ca', 'co.uk', 'fr'], icloud: ['com'], live: ['com', 'ca', 'co.uk', 'fr']
  };
  var REAL_OTHERS = ['mail', 'email', 'gmx', 'aol', 'msn', 'shaw', 'telus', 'rogers', 'sympatico', 'bell', 'videotron', 'cogeco', 'eastlink', 'proton', 'protonmail', 'ymail', 'rocketmail', 'hey', 'fastmail', 'zoho'];

  // Edit distance where swapping two neighbouring letters counts as one change.
  function osa(a, b) {
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[a.length][b.length];
  }

  function suggestEmail(email) {
    var at = email.lastIndexOf('@');
    var local = email.slice(0, at), domain = email.slice(at + 1);
    var dot = domain.indexOf('.');
    var name = dot > 0 ? domain.slice(0, dot) : domain;
    var tld = dot > 0 ? domain.slice(dot + 1) : '';
    if (REAL_OTHERS.indexOf(name) !== -1 || name.length < 3) return null;
    var best = null, bestD = 99;
    Object.keys(PROVIDERS).forEach(function (p) {
      var d = name === p ? 0 : osa(name, p);
      if (d < bestD) { bestD = d; best = p; }
    });
    if (!best || bestD > (best.length >= 6 ? 2 : 1)) return null;
    var tlds = PROVIDERS[best];
    var goodTld = tlds.indexOf(tld) !== -1 ? tld : (tld === 'ca' || tld === 'c' ? (tlds.indexOf('ca') !== -1 ? 'ca' : 'com') : 'com');
    var fixed = best + '.' + goodTld;
    return fixed === domain ? null : local + '@' + fixed;
  }

  function answersProps() {
    var p = { agp_test: C.test, agp_variant: st.arm, agp_channel: attr.ch };
    // Offer tag from the variant (e.g. ll-deal): lets Klaviyo give these signups their own flow.
    var vEl = variants[st.arm];
    var offer = vEl && vEl.getAttribute('data-offer');
    if (offer) p.popup_offer = offer;
    var a = st.answers || {};
    for (var k in a) p[k] = a[k];
    return p;
  }

  Popup.prototype.submit = function (form) {
    var kind = form.getAttribute('data-agp-form');
    var input = form.querySelector('input[name="' + kind + '"]');
    var err = form.querySelector('.agp__error');
    var btn = form.querySelector('button[type="submit"]');
    var hp = form.querySelector('.agp__hp');
    var raw = (input.value || '').trim();
    var self = this;

    function fail(msg) {
      err.classList.remove('is-hint');
      err.textContent = msg;
      err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
    err.hidden = true;
    input.removeAttribute('aria-invalid');

    var value;
    if (kind === 'email') {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(raw)) return fail('Please enter a valid email address.');
      value = raw.toLowerCase();
      // Catch gmial.com, hotmial.com, outlok.com, gmail.con and friends once; a second
      // submit of the same address goes through as typed.
      var fix = suggestEmail(value);
      if (fix && form.getAttribute('data-checked') !== value) {
        form.setAttribute('data-checked', value);
        err.textContent = 'Did you mean ';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'agp__fix';
        b.textContent = fix;
        b.addEventListener('click', function () {
          input.value = fix;
          track('email_fix', { i: self.i, f: 'accept' });
          form.requestSubmit ? form.requestSubmit() : self.submit(form);
        });
        err.appendChild(b);
        err.appendChild(document.createTextNode('?'));
        err.classList.add('is-hint');
        err.hidden = false;
        return;
      }
      if (fix) track('email_fix', { i: self.i, f: 'ignore' });
    } else {
      var digits = raw.replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      if (digits.length !== 10) return fail('Please enter a 10-digit phone number.');
      value = '+1' + digits;
    }
    if (hp && hp.value) return self.next(); // bot

    btn.disabled = true;
    btn.classList.add('is-loading');

    var p;
    if (PREVIEW && !KL_LIVE) {
      log('would subscribe', kind, value, answersProps());
      p = Promise.resolve();
    } else if (kind === 'email') {
      // Profile properties (popup_offer, answers) go first, so they're already on the profile
      // when the list signup starts Klaviyo's welcome flows and their filters run.
      p = klProfile({ email: value }, answersProps()).then(function () {
        return klSubscribe({ email: value });
      });
    } else {
      var attrs = { phone_number: value };
      if (st.email) attrs.email = st.email;
      p = klSubscribe(attrs);
    }

    p.then(function () {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (kind === 'email') {
        st.submitted = Date.now();
        st.email = value;
        save();
        track('submit', { i: self.i });
        syncCart();
        if (!PREVIEW || KL_LIVE) {
          klEvent({ email: value }, 'AG Popup Submitted', answersProps());
          try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: value }); } catch (e) {}
        }
      } else {
        st.phone = 1;
        save();
        track('phone', { i: self.i });
      }
      self.next();
    }).catch(function () {
      track('submit_err', { i: self.i, f: kind });
      fail('Something went wrong. Please try again.');
    });
  };

  Popup.prototype.reachedSuccess = function (step) {
    var code = step.getAttribute('data-code');
    if (code && step.getAttribute('data-apply') === 'true' && !PREVIEW && !st.applied) {
      st.applied = 1;
      save();
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    }
  };

  Popup.prototype.copy = function (btn) {
    var step = this.steps[this.i];
    var code = step.getAttribute('data-code') || '';
    var label = btn.querySelector('.agp-code__label') || btn;
    var done = function () {
      var orig = btn.getAttribute('data-orig') || label.textContent;
      btn.setAttribute('data-orig', orig);
      label.textContent = btn.getAttribute('data-copied') || 'Copied!';
      setTimeout(function () { label.textContent = orig; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else done();
    track('copy', { i: this.i });
  };

  Popup.prototype.cta = function () {
    track('cta', { i: this.i });
    if (DESIGN) return;
    this.leave();
  };

  // Last step done: go to the landing page (e.g. /pages/surprise or
  // /products/laundry-leaf-detergent-sheets?view=surprise). The full address counts, so
  // ?view=surprise on the same product page is a different page. Same address or none = close.
  Popup.prototype.leave = function () {
    var step = this.steps[this.i];
    var url = step.getAttribute('data-url') || '';
    var code = step.getAttribute('data-code') || '';
    var here = false;
    try {
      var u = new URL(url, location.origin);
      here = u.origin === location.origin && u.pathname + u.search === location.pathname + location.search;
    } catch (e) {}
    if (!url || here) {
      st.done = 1;
      save();
      return this.hide();
    }
    st.done = 1;
    save();
    if (code && step.getAttribute('data-apply') === 'true' && !PREVIEW) {
      location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(url);
    } else {
      location.href = url;
    }
  };

  Popup.prototype.trap = function (e) {
    var f = [].slice.call(this.dialog.querySelectorAll('button, input, a[href]')).filter(function (n) {
      return !n.disabled && n.offsetParent !== null && !n.classList.contains('agp__hp');
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Popup.prototype.showPill = function () {
    if (!this.pill) return;
    var p = this.pill;
    p.hidden = false;
    void p.offsetWidth;
    p.classList.add('is-visible');
    this.placePill();
    var self = this;
    clearInterval(this.pillTimer);
    this.pillTimer = setInterval(function () { self.placePill(); }, 400);
  };

  // Keep the pill out of the way: sit just above a sticky add-to-cart bar, and step aside while
  // the cart drawer, menu or any other pop-up window is open.
  Popup.prototype.placePill = function () {
    var p = this.pill;
    var covered = document.body.classList.contains('overflow-hidden') ||
      !!document.querySelector('cart-drawer.active, .drawer.active, details[open] > .menu-drawer');
    p.classList.toggle('is-covered', covered);
    if (p.classList.contains('agp-pill--side_left')) return;
    var lift = 0;
    document.querySelectorAll('.sticky-atc, sticky-atc').forEach(function (bar) {
      var r = bar.getBoundingClientRect();
      var cs = getComputedStyle(bar);
      if (r.height && cs.display !== 'none' && cs.visibility !== 'hidden' && r.top < window.innerHeight && r.bottom > window.innerHeight - 4) {
        lift = Math.max(lift, window.innerHeight - r.top);
      }
    });
    p.style.bottom = lift ? lift + 10 + 'px' : '';
  };

  Popup.prototype.hidePill = function () {
    if (!this.pill) return;
    clearInterval(this.pillTimer);
    this.pill.classList.remove('is-visible');
    this.pill.hidden = true;
  };

  /* ---------- Klaviyo client API ---------- */

  function klPost(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(C.klaviyoKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: KL_REVISION },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      return r;
    });
  }

  // Klaviyo's client subscription takes no "subscriptions" field (400 "not a valid field", found
  // 2026-10-30): the email / phone_number given is the opt-in for that channel.
  function klSubscribe(attrs) {
    // Klaviyo shows this as the signup's source (Method Detail), e.g. "Laundry Leaf - Landing Page".
    var vEl = variants[st.arm];
    var source = (vEl && vEl.getAttribute('data-source')) || 'AG Popup ' + C.test + ' / ' + st.arm;
    var data = {
      type: 'subscription',
      attributes: {
        custom_source: source,
        profile: { data: { type: 'profile', attributes: attrs } }
      }
    };
    if (C.listId) data.relationships = { list: { data: { type: 'list', id: C.listId } } };
    return klPost('subscriptions', { data: data });
  }

  function klProfile(ids, props) {
    var attrs = { properties: props };
    for (var k in ids) attrs[k] = ids[k];
    return klPost('profiles', { data: { type: 'profile', attributes: attrs } }).catch(function () {});
  }

  function klEvent(ids, name, props) {
    return klPost('events', {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: name } } },
          profile: { data: { type: 'profile', attributes: ids } }
        }
      }
    }).catch(function () {});
  }

  /* ---------- triggers ---------- */

  function busy() {
    // Another modal or the cart drawer is open: wait.
    if (document.body.classList.contains('overflow-hidden')) return true;
    var d = document.querySelector('cart-drawer.active, .drawer.active, details[open] > .menu-drawer');
    return !!d;
  }

  function openWhenFree(pop, src) {
    if (cur) return;
    if (!busy()) return pop.open(src);
    var t = setInterval(function () {
      if (cur) return clearInterval(t);
      if (!busy()) { clearInterval(t); pop.open(src); }
    }, 1000);
  }

  function armTriggers(pop) {
    var el = pop.el;
    var delay = parseFloat(el.getAttribute('data-delay'));
    var scroll = parseFloat(el.getAttribute('data-scroll'));
    var exit = el.getAttribute('data-exit') === 'true' && window.matchMedia('(pointer: fine)').matches;
    var scrollUp = el.getAttribute('data-scrollup') === 'true' && !window.matchMedia('(pointer: fine)').matches;
    // One switch for every trigger: the first to fire opens the popup and the rest are removed.
    var fired = false, timer;
    // Fetch its images now, during the wait, so the background is there the moment it opens.
    el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });

    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && (window.scrollY / max) * 100 >= scroll) fire('scroll');
    }
    function onOut(e) { if (!e.relatedTarget && e.clientY <= 0) fire('exit'); }
    // Phones' "leaving" signal: after scrolling down at least 600px, a fast flick back up of 200px+.
    var peak = window.scrollY, lastY = window.scrollY, lastT = Date.now();
    function onUp() {
      var y = window.scrollY, t = Date.now();
      if (y > peak) peak = y;
      var speed = (lastY - y) / Math.max(1, t - lastT);
      if (peak > 600 && peak - y > 200 && speed > 1) fire('scrollup');
      lastY = y;
      lastT = t;
    }
    function fire(src) {
      if (fired) return;
      fired = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', onUp);
      document.removeEventListener('mouseout', onOut);
      openWhenFree(pop, src);
    }
    if (delay >= 0) timer = setTimeout(function () { fire('delay'); }, delay * 1000);
    if (scroll >= 0) window.addEventListener('scroll', onScroll, { passive: true });
    if (exit) document.addEventListener('mouseout', onOut);
    if (scrollUp) window.addEventListener('scroll', onUp, { passive: true });
  }

  /* ---------- editor ---------- */

  var pops = {};
  function popFor(el) {
    if (!el) return null;
    var sid = el.getAttribute('data-section-id');
    if (!pops[sid] || pops[sid].el !== el) pops[sid] = new Popup(el);
    return pops[sid];
  }
  function popBySection(sid) { return popFor(document.getElementById('agp-' + sid)); }

  if (DESIGN) {
    document.addEventListener('shopify:section:select', function (e) {
      var p = popBySection(e.detail.sectionId);
      if (p) p.open('design', 0);
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var p = popBySection(e.detail.sectionId);
      if (p) p.hide();
    });
    document.addEventListener('shopify:section:load', function (e) {
      collect();
      var p = popBySection(e.detail.sectionId);
      if (p && cur && cur.sid === e.detail.sectionId) { cur = null; p.open('design', 0); }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var p = popBySection(e.detail.sectionId);
      if (!p) return;
      var n = p.steps.indexOf(e.target.closest('.agp__step'));
      if (cur !== p) p.open('design', Math.max(n, 0));
      else p.go(Math.max(n, 0));
    });
    return;
  }

  /* ---------- start ---------- */

  // Small label so whoever is previewing knows they're in preview, with a way out.
  function previewBadge(text) {
    var b = document.createElement('div');
    b.className = 'agp-badge';
    b.textContent = text + ' · ';
    var reset = document.createElement('a');
    reset.href = location.pathname + '?agp=reset';
    reset.textContent = 'Restart';
    var off = document.createElement('a');
    off.href = location.pathname + '?agp=off';
    off.textContent = 'End';
    b.appendChild(reset);
    b.appendChild(document.createTextNode(' · '));
    b.appendChild(off);
    document.body.appendChild(b);
  }

  function start() {
    if (FORCE) {
      st.arm = FORCE;
      var pv = popFor(variants[FORCE]);
      previewBadge(pv ? 'Popup preview: ' + FORCE + (KL_LIVE ? ' (real signup)' : '') : 'No popup variant named "' + FORCE + '"');
      if (!pv) { log('no variant named', FORCE, 'found:', Object.keys(variants)); return; }
      if (C.hideKlaviyo) html.classList.add('agp-hide-kl');
      if (st.submitted) return;
      if (G.closedAt && !G.pillOff) return pv.showPill();
      // Preview waits like a real visit (delay, scroll, exit intent), the same as the live Klaviyo popup.
      return armTriggers(pv);
    }

    if (!C.enabled || !C.test || !C.endpoint) return;
    // Not a popup page (no line in "Pages and their popups", or a landing page in "Keep Klaviyo's
    // popup off"): leave everything to Klaviyo's popup here.
    if (C.here === false) return;
    if (excluded() || identified() || isBuyer()) return;
    if (C.measure) return measureKlaviyo();

    // Each page has its own designs (e.g. Laundry Leaf vs Dishwasher Tablets). The visitor keeps
    // one design per set of designs, so their pick sticks on every visit to that page.
    var cands = pageVariants();
    if (!cands.length) return;
    var group = cands.slice().sort().join('+');
    st.arms = st.arms || {};
    var arm = st.arms[group];
    if (!arm || cands.indexOf(arm) === -1 || !armValid(arm)) {
      arm = pickArm(cands);
      if (!arm) return;
      st.arms[group] = arm;
    }
    st.arm = arm;
    st.enteredArms = st.enteredArms || {};
    if (!st.enteredArms[arm]) {
      st.enteredArms[arm] = Date.now();
      save();
      track('enter', attrFields());
    }
    save();
    syncCart();
    if (C.hideKlaviyo) html.classList.add('agp-hide-kl');

    var pop = popFor(variants[st.arm]);
    if (!pop || st.submitted || st.done) return;

    var now = Date.now();
    // Opened but never closed (tab killed before pagehide): count it as a close.
    if (G.openAt && !(G.closedAt > G.openAt)) {
      G.closedAt = G.openAt;
      G.closes = (G.closes || 0) + 1;
      G.openAt = 0;
    }
    if (G.closedAt && now - G.closedAt > FORGET_MS) { G.closes = 0; G.closedAt = 0; G.pillOff = 0; }
    save();
    // Closed recently, or closed often enough that it no longer opens on its own: pill only.
    if (G.closedAt && now - G.closedAt < waitAfter(G.closes)) {
      if (!G.pillOff) pop.showPill();
      return;
    }
    armTriggers(pop);
  }

  // Control theme ("Klaviyo control" mode): nothing of ours shows. Klaviyo's popup runs as normal
  // and is counted on the same pages, with the same visitor rules, as arm "klaviyo", so the
  // dashboard compares like with like (visitors, views, signups, revenue).
  function measureKlaviyo() {
    st.arm = 'klaviyo';
    st.enteredArms = st.enteredArms || {};
    if (!st.enteredArms.klaviyo) {
      st.enteredArms.klaviyo = Date.now();
      track('enter', attrFields());
    }
    save();
    syncCart();
    var ids = (C.klForms || []).map(function (x) { return String(x).trim(); }).filter(Boolean);
    window.addEventListener('klaviyoForms', function (e) {
      var d = e.detail || {};
      if (ids.length && ids.indexOf(String(d.formId)) === -1) return;
      if (d.type === 'open') track('view', { src: 'klaviyo' });
      else if (d.type === 'submit' && !st.submitted) {
        st.submitted = Date.now();
        save();
        track('submit', { src: 'klaviyo' });
        syncCart();
      }
    });
  }

  window.addEventListener('pagehide', function () {
    if (cur && !st.submitted && !PREVIEW) {
      G.closedAt = Date.now();
      G.closes = (G.closes || 0) + 1;
      G.openAt = 0;
      save();
      track('close', { i: cur.i, st: cur.type(), how: 'nav' });
    }
  });

  start();
})();
